"use client"

import withProductHOC from "@/HOC/withProductHOC";
import ButtonComponent from "@/Inputs/ButtonComponent";
import { cn, FloatValues } from "@/services/Methods/normalMethods";
import { CircularProgress, Link } from "@mui/material";
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { notFoundImage } from '@/assets/images';
import Image from "next/image";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { storeAssigned } from "@/services/Methods/normalMethods";
import { getCurrencySign } from "@/services/Methods/normalMethods";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

const Ambassador = (props) => {
    const { loading, onetime = true, allProductState, _addToCartFunction, activeStep = "", setActiveStep, setAddToCartProduct } = props;
    // console.log("allProductState", allProductState);
    const router = useRouter();
    useEffect(() => {
        const ROLE = localStorageCall().getItem('customerTypeDescr')?.role || 'normal';
        const isUserLogin = localStorageCall().getItem('Token');

        console.log("ROLE==================", ROLE);

        if ((ROLE === 'member' || ROLE === 'ambassador') && isUserLogin) {
            setAddToCartProduct({ normalProducts: [] });
            router.push(`/${storeAssigned()}`)
        }

    }, [])
    return (
        loading ? (
            <div className="loder_div">
                <CircularProgress className='' />
            </div>
        )
            :
            <div className="w-full text-center flex-col">
                <div className='w-full my-0 mx-auto flex flex-col ambester_products'>
                    {(allProductState?.length > 0) ?
                        _.map(allProductState, ({ points, id, image, title, price, stock, out_of_stock, category_id, ...row }, index) => (
                            title === 'Ambassador Registration Fee' && <div
                                key={"Allproduct" + index}
                                className="rounded-[0px] bg-[#fff] pt-[22px] p-[22px] flex flex-col border-solid border-2 border-[rgba(0,0,0,.125)] mx-[18px] my-[18px]"
                            >
                                <div className="flex items-center">
                                    <div
                                        className="max-w-[150px] mr-[20px] mb-[20px] w-full flex items-center justify-center cursor-pointer"
                                    >
                                        {image
                                            ?
                                            <img src={image} className="w-full h-full object-contain" alt="product" />
                                            :
                                            <Image src={notFoundImage} alt="Image 10" className="w-full h-full object-contain" />
                                        }
                                    </div>
                                    <div className="w-full">
                                        <h3 className="xl:text-[24px] md:text-[17px] sm:text-[16px] text-lg font-normal text uppercase leading-[1.43]">
                                            {title}
                                        </h3>
                                    </div>
                                </div>
                                <div className="flex flex-col justify-between">
                                    <div className="btn-group w-full text-center">
                                        {(() => {
                                            // let oneTimePrice = row['normal_oneTime'] || price;
                                            let oneTimePrice = row['normal_oneTime'] === 0 ? row['normal_oneTime'] : row['normal_oneTime'] || price;

                                            return (
                                                <>
                                                    <>
                                                        {onetime &&
                                                            <div className={cn(`block w-full text-start max-w-[max-content] text-black xl:text-[24px] sm:text-[20px] text-[20px] font-semibold transtion-all duration-300 ease-in-out`, 'oneTime')}
                                                            >
                                                                {getCurrencySign(_.upperCase(storeAssigned()))}{FloatValues(oneTimePrice)}
                                                            </div>
                                                        }
                                                        <ButtonComponent classes={"xl:mb-0 lg:mb-0  mb-0 rounded-[0px] py-[7.5px] px-[20px] max-w-[196px] ml-auto flex justify-end gap-[23px] items-center bg-[#fff] text-[#444] border-0 hover:border-0"} type="button"
                                                            onClick={() => {
                                                                if (process.env.NEXT_PUBLIC_COMING_SOON !== 'true') {
                                                                    _addToCartFunction(id, 'autoship', category_id);
                                                                    setActiveStep(activeStep + 1)
                                                                    localStorageCall().setItem('activeStep', 3);
                                                                }
                                                            }}
                                                        >
                                                            <p className='text-[18px] text-[#444] leading-[1.93]'>Select</p>
                                                            <TrendingFlatIcon />
                                                        </ButtonComponent>
                                                    </>
                                                </>
                                            )
                                        })()}
                                    </div>
                                </div>
                            </div>
                        ))
                        :
                        <div className="flex justify-center items-center w-full text-[18px] col-span-full">No Product Found</div>
                    }
                </div>
                <Link
                    component="button"
                    underline="hover"
                    variant="body2"
                    color='info'
                    className="text-[16px] no_thaks_btn"
                    onClick={() => {
                        localStorageCall().setItem('activeStep', 3);
                        setActiveStep(activeStep + 1)
                    }}
                >
                    No thanks. Continue
                </Link>
            </div>
    )
}

export default withProductHOC(Ambassador, 'normal');